export default {"src":"/_next/static/media/Logo-setdig-colorida.de843ad5.svg","height":125,"width":460,"blurWidth":0,"blurHeight":0};